import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { addDays } from 'date-fns';
import sv from 'date-fns/locale/sv';
import ReactDatePicker from 'react-datepicker';
import LanguageContext from '@lib/contexts/languageContext';

const Wrapper = styled.div`
  .react-datepicker {
    font-family: 'Libre Franklin', sans-serif;
    width: 100%;
    border: 0;

    .react-datepicker__header {
      background-color: white;
      border-bottom: none;
    }

    .react-datepicker__day-name {
      font-weight: 600;
      color: #5d5d5d;
    }

    .react-datepicker__month-container {
      width: 100%;
    }

    .react-datepicker__day-names,
    .react-datepicker__week {
      display: flex;
    }

    .react-datepicker__day-name,
    .react-datepicker__day,
    .react-datepicker__time-name {
      font-size: 13px;
      transition: all 200ms ease;
      width: 100%;
    }
    .react-datepicker__day {
      line-height: 35px;
    }
    .react-datepicker__day--selected,
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__day--in-range {
      background: none;
      border-radius: 50%;
      transition: all 300ms ease;
      font-weight: bold;
      position: relative;
      z-index: 0;

      &:hover {
        background: none;
        color: white;
        &:before {
          background-color: #56b9e5;
          color: white;
        }
      }

      &:before {
        content: '';
        position: absolute;
        border-radius: 50%;
        background-color: #56b9e5;
        top: 0;
        left: calc(50% - 17px);
        width: 35px;
        height: 35px;
        z-index: -1;
      }

      &.react-datepicker__day--today {
        text-decoration: none;
      }
    }

    .react-datepicker__day--outside-month {
      color: #a1a1a1;

      &.react-datepicker__day--selected {
        color: white;
      }
    }

    .react-datepicker__day--today {
      text-decoration: underline;
    }

    .react-datepicker__current-month {
      margin-bottom: 1em;
      font-weight: normal;
    }
  }
`;

const DatePicker = ({ handleChange = null }) => {
  const locale = useContext(LanguageContext);
  const [startDate, setStartDate] = useState(addDays(new Date(), 1));

  const onChange = date => {
    setStartDate(date);
    handleChange?.(date);
  };

  return (
    <Wrapper>
      <link rel="stylesheet" href="/static/css/react-datepicker.css" />
      <ReactDatePicker
        locale={locale === 'en' ? 'en-US' : sv}
        selected={startDate}
        onChange={onChange}
        useWeekdaysShort={false}
        inline
      />
    </Wrapper>
  );
};

export default DatePicker;
